/**
 * ProducerPopup Presentational Component
 * For more informations about this kind of component, read README
 *
 * References:
 *  - https://usehooks.com/useWindowSize/
 */

import React from 'react';
import { Load } from '../../../../components';
import styles from './Loading.module.css';

/**
 * useLoading UI logic hook.
 * Enable eventsHandlres to control UI behaviour and localStates to represent UI states.
 * @param {Commands} commands
 * @returns local states and events handles
 */
function useLoading(commands) {
  return {
    localStates: {
    },
    eventsHandlers: {
    },
  };
}

/**
 * Loading purely presentational component
 * Get user events and pass it to UI hook
 * @returns JSX presentational component
 */
export default function Loading(props) {
  const {
    commands,
    sharedStates,
  } = props;

  const { localStates, eventsHandlers } = useLoading(commands);

  if(sharedStates.userLocation) return null;

  return (
    <div className={styles['blurBackground']}>
      <Load 
      size='medium'
      />
      <div className={styles["textBox"]}>
        <p className={styles['locallText']}>Locall<span className={styles['text']}>izando...</span></p>
      </div>
    </div>
  ); 
}
